import { createSlice } from "@reduxjs/toolkit"

export const pickupAnalyticsListSlice = createSlice({
	name: "pickupAnalytics",
	initialState: {
		pickupAnalytics: "",
		errors: [],
	},

	reducers: {
        getPickupAnalytics: (state, action) => {
            // console.log(action.payload);
			state.pickupAnalytics = action.payload
		},
		getPickupAnalyticsList: (state, action) => {
            
			state.pickupAnalytics = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getPickupAnalytics, getPickupAnalyticsList, getErrors} = pickupAnalyticsListSlice.actions

export default pickupAnalyticsListSlice.reducer

